import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";
import Input from "../../components/forms-fields/Input";
import { useFormik } from "formik";
import moment from 'moment';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { PUT_UPDATE_ROTA_TEMPLATE_URL, ADMIN_ID } from "../../env";
import {
  updateRecords,
  catchAsync,
  isSuccess,
  toastSuccessMessages,
  toastErrorMessages,
} from "../../helper/helper";
import SelectBox from "../../components/forms-fields/SelectBox";
import { editRotaTemplate } from "../../schemas";

function EditRotaTemplate({ subModalEditRota, rotaStockDetail }) {
  const handleShowHideModal = () => {
    subModalEditRota((prevShow) => !prevShow);
  };

  const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);
  const [isToastEditRotaTemplate, setIsToastEditRotaTemplate] = useState(false);
  const [startDateStatus, setStartDateStatus] = useState(false);
  const [endDateStatus, setEndDateStatus] = useState(false);
  const [disabledStatus, setDisabledStatus] = useState(false);
  const todayDate = moment().valueOf();

  const rotaTempWeeksOptions = [
    { value: 2, label: 2 },
    { value: 4, label: 4 },
  ];

  const statusOptions = [
    { value: "active", label: "Active" },
    { value: "saved", label: "Saved" },
    { value: "future", label: "Future" },
    { value: "Inactive", label: "In Active" },
  ];

  const [suFormData, setSuFormData] = useState({
    tempId: rotaStockDetail?._id,
    rotaTemplateTitle: rotaStockDetail?.rotaTemplateTitle,
    templateWeeks: rotaStockDetail?.templateWeeks,
    status: rotaStockDetail?.status,
    startDate: rotaStockDetail?.startDate || null,
    endDate: rotaStockDetail?.endDate || null, // Allow endDate to be null
    addedby: rotaStockDetail?.addedby,
    lastModifiedBy: ADMIN_ID,
  });

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
  } = useFormik({
    initialValues: suFormData,
    validationSchema: editRotaTemplate,
    onSubmit: async (values) => {
      try {
        setIsSubmitButtonClicked(true);
        await postEditRotaTemplateFormData(values);
      } catch (error) {
        
      }
    },
  });

  const processPostRecords = (method, data) => {
    if (data?.status !== isSuccess) {
      setIsToastEditRotaTemplate(true);
      toastErrorMessages(toast.error, data?.message, "", 500, 500);
      setIsSubmitButtonClicked(false);
      handleShowHideModal();
    } else if (method === "postEditRotaTemplateFormData" && data?.status === isSuccess) {
      setIsToastEditRotaTemplate(true);
      toastSuccessMessages(toast.success, data?.message, "", 500, 500);
      setIsSubmitButtonClicked(false);
      setTimeout(() => {
        handleShowHideModal();
      }, 2000);
    }
  };

  const postEditRotaTemplateFormData = catchAsync(async () => {
    const updateValues = {
      ...values,
    };
    const response = await updateRecords(PUT_UPDATE_ROTA_TEMPLATE_URL, updateValues);
    processPostRecords("postEditRotaTemplateFormData", response);
    setIsSubmitButtonClicked(false);
  });

  const onChangeSelectStatus = (e) => {
    setFieldValue("status", e.target.value);
  };

  useEffect(() => {
    if (values.status !== "saved") {
      setStartDateStatus(true);
      setEndDateStatus(true);
      if (values?.startDate === 0) {
        setFieldValue("startDate", todayDate)
      }

    } else {
      setStartDateStatus(false);
      setEndDateStatus(false);
      setFieldValue("startDate", 0);
    }
  }, [values.status]);

  useEffect(() => {
    (rotaStockDetail?.startDate <= todayDate && rotaStockDetail?.status === "active") ? (
      setDisabledStatus(true)
    ) : (
      setDisabledStatus(false)
    )
  }, [rotaStockDetail, todayDate]);

  return (
    <>
      <div className="incidents consentCapacityAddNew">
        <form onSubmit={handleSubmit}>
          <div className="formBlockContent">
            <div className="row">
              <div className="col-md-12">
                <Input
                  type="text"
                  name="rotaTemplateTitle"
                  value={values?.rotaTemplateTitle}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  labelText="Name"
                  customError={touched?.rotaTemplateTitle && errors?.rotaTemplateTitle}
                  errorMessage={errors?.rotaTemplateTitle}
                  erroClass={touched?.rotaTemplateTitle && errors?.rotaTemplateTitle ? "validationError" : ""}
                  requiredStar={true}
                />
              </div>

              <div className="col-md-12">

                <SelectBox
                  id="templateWeeks"
                  name="templateWeeks"
                  value={values?.templateWeeks}
                  onChange={handleChange}
                  options={rotaTempWeeksOptions}
                  labelText="Weeks"
                  requiredStar={true}
                />
              </div>

              <div className="col-md-12">
                <SelectBox
                  id="status"
                  name="status"
                  value={values?.status}
                  onChange={onChangeSelectStatus}
                  options={statusOptions}
                  labelText="Status"
                  requiredStar={true}
                // disabled={values?.status === "Inactive" ? true : disabledStatus}
                />
              </div>

              {(startDateStatus && values?.status != "saved") && (
                <div className="col-md-12">
                  <Input
                    type="date"
                    name="startDate"
                    value={moment(values?.startDate).format("YYYY-MM-DD")}
                    onChange={(e) => {
                      setFieldValue('startDate', moment(e.target.value).valueOf());
                    }}
                    onBlur={handleBlur}
                    labelText="Start Date"
                    customError={touched?.startDate && errors?.startDate}
                    errorMessage={errors?.startDate}
                    erroClass={touched?.startDate && errors?.startDate ? "validationError" : ""}
                    requiredStar={true}
                  // disabledStatus={values?.status === "Inactive" ? true : disabledStatus}
                  />
                </div>
              )}

              {(endDateStatus && values?.status != "saved") && (
                <div className="col-md-12">
                  <Input
                    type="date"
                    name="endDate"
                    value={values?.endDate ? moment(values?.endDate).format("YYYY-MM-DD") : ''}
                    onChange={(e) => {
                      setFieldValue('endDate', e.target.value ? moment(e.target.value).valueOf() : null);
                    }}
                    onBlur={handleBlur}
                    labelText="End Date"
                    customError={touched?.endDate && errors?.endDate}
                    errorMessage={errors?.endDate}
                    erroClass={touched?.endDate && errors?.endDate ? "validationError" : ""}
                    requiredStar={true}
                  // disabledStatus={values?.status === "Inactive" ? true : false}
                  />
                </div>
              )}
            </div>
          </div>

          <div className="formActionButtons">
            <span onClick={subModalEditRota} className="btn btn-sm btn-outline-primary">
              Close
            </span>
            {isSubmitButtonClicked ? (
              <Button className="btn-sm" variant="primary" disabled>
                Loading...
              </Button>
            ) : (
              <Button className="btn-sm" variant="primary" type="submit">
                Save
              </Button>
            )}
          </div>
        </form>
      </div>
      {isToastEditRotaTemplate && <ToastContainer />}
    </>
  );
}

export default EditRotaTemplate;
